import BaseEnum from './BaseEnum';

class NewBranches extends BaseEnum {
  fieldsMap = {
    Id: 'Id',
    Branch: 'Branch',
    Status: 'Status',
    Type: 'Type',
    Customer: 'Customer',
    Territory: 'Territory',
    Brand: 'Brand',
    'Branch_Name': 'Branch Name',
    'Branch_Telephone': 'Branch Telephone',
    'General_Email': 'General Email',
    'Accounts_Email': 'Accounts Email',
    'Sales_Contact_Name': 'Sales Contact Name',
    'Sales_Contact_Email': 'Sales Contact Email',
  }
}

export default NewBranches.make();